/* AD DEFENSE – refonte 2026 : apparition au défilement + inclinaison du visuel du héros */
(function () {
  var html = document.documentElement;
  html.classList.add('dfz-ready');

  // Description de catégorie : cachée, dépliable avec « Voir la description »
  document.querySelectorAll('.collection-hero__description').forEach(function (d) {
    if (!d.textContent.trim()) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dfz-more';
    b.setAttribute('aria-expanded', 'false');
    if (!d.id) d.id = 'AdCollDesc';
    b.setAttribute('aria-controls', d.id);
    b.innerHTML = '<span>Voir la description</span><i aria-hidden="true">+</i>';
    b.addEventListener('click', function () {
      var open = !d.classList.contains('is-open');
      d.style.maxHeight = open ? d.scrollHeight + 'px' : '0px';
      d.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.querySelector('span').textContent = open ? 'Masquer la description' : 'Voir la description';
    });
    d.insertAdjacentElement('beforebegin', b);
    d.classList.add('dfz-desc-ready');
  });
  // Carrousel du haut de page
  document.querySelectorAll('.dfz-carousel').forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll('.dfz-slide'));
    var tabs = [].slice.call(root.querySelectorAll('.dfz-tab'));
    if (slides.length < 2) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Défilement auto gardé même si Windows/macOS demande moins d'animations (sinon le carrousel restait figé)
    var auto = root.hasAttribute('data-autoplay');
    if (!auto) root.removeAttribute('data-autoplay');
    var cur = 0;
    function go(i) {
      i = (i + slides.length) % slides.length;
      if (i === cur) return;
      slides.forEach(function (sl, k) {
        var on = k === i;
        sl.classList.toggle('is-active', on);
        if (on) { sl.removeAttribute('aria-hidden'); sl.removeAttribute('inert'); }
        else { sl.setAttribute('aria-hidden', 'true'); sl.setAttribute('inert', ''); }
        var v = sl.querySelector('.dfz-hero__visual'); if (v) v.tabIndex = on ? 0 : -1;
      });
      tabs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        t.classList.toggle('is-done', k < i);
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        // relance la barre de progression
        var bar = t.querySelector('i'); bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
      });
      cur = i;
      var eb = slides[i].querySelector('.dfz-eyebrow');
      if (eb && window.adScramble) { delete eb.dataset.dfzDone; window.adScramble(eb); }
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { go(k); });
      t.querySelector('i').addEventListener('animationend', function () { if (auto && k === cur) go(cur + 1); });
    });
    root.querySelectorAll('.dfz-arrow-btn').forEach(function (b) {
      b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); });
    });
    // Pause au survol / au clavier
    function pause(on) { root.classList.toggle('is-paused', on); }
    root.addEventListener('mouseenter', function () { pause(true); });
    root.addEventListener('mouseleave', function () { pause(false); });
    root.addEventListener('focusin', function () { pause(true); });
    root.addEventListener('focusout', function () { pause(false); });
    // Flèches du clavier sur les onglets
    root.querySelector('.dfz-tabs').addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { go(cur + (e.key === 'ArrowRight' ? 1 : -1)); tabs[cur].focus(); e.preventDefault(); }
    });
    // Glissé au doigt
    var x0 = null, y0 = null;
    var area = root.querySelector('.dfz-slides');
    area.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; }, { passive: true });
    area.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
    // Éditeur de thème : afficher la bannière sélectionnée
    document.addEventListener('shopify:block:select', function (e) {
      var k = slides.indexOf(e.target); if (k > -1) { auto = false; go(k); }
    });
  });

  if (!html.classList.contains('dfz-io')) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function scan(root) {
    (root || document).querySelectorAll('[data-dfz-reveal]:not(.is-in)').forEach(function (el) { io.observe(el); });
  }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // 1. (barre de progression rouge du haut retirée à sa demande)
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || window.pageYOffset;
      // Parallaxe du texte du haut de page (ordinateur seulement : sur téléphone le texte
      // est sous le produit et le bouton s'effaçait dès le début du défilement)
      var parallax = window.innerWidth >= 990;
      if (!parallax || y < window.innerHeight * 1.4) {
        document.querySelectorAll('.dfz-hero__text').forEach(function (t) {
          t.style.transform = parallax ? 'translateY(' + (y * 0.22).toFixed(1) + 'px)' : '';
          t.style.opacity = parallax ? Math.max(0, 1 - y / 700).toFixed(3) : '';
        });
      }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // 2. Étiquettes rouges qui se « décodent » à l'apparition
  var CH = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/#';
  function scramble(el) {
    if (el.dataset.dfzDone) return;
    el.dataset.dfzDone = '1';
    var final = el.textContent, n = final.length, frame = 0, total = 22;
    (function step() {
      var out = '';
      for (var i = 0; i < n; i++) {
        var c = final[i];
        out += (c === ' ' || c === '·' || i < (frame / total) * n) ? c : CH[Math.floor(Math.random() * CH.length)];
      }
      el.textContent = out;
      if (++frame <= total) requestAnimationFrame(step); else el.textContent = final;
    })();
  }
  window.adScramble = scramble;
  var io2 = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { scramble(e.target); io2.unobserve(e.target); } });
  }, { threshold: 0.6 });
  document.querySelectorAll('.dfz-eyebrow').forEach(function (el) { if (!el.closest('.dfz-slide:not(.is-active)')) io2.observe(el); });

  // 3. Chiffres clés qui défilent (100 €)
  document.querySelectorAll('.dfz-hero__proofs strong').forEach(function (el) {
    var m = el.textContent.match(/^(\d+)(\D*)$/);
    if (!m) return;
    var to = parseInt(m[1], 10), suf = m[2], t0 = null;
    el.textContent = '0' + suf;
    setTimeout(function () {
      requestAnimationFrame(function tick(ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / 1200), e = 1 - Math.pow(1 - k, 3);
        el.textContent = Math.round(to * e) + suf;
        if (k < 1) requestAnimationFrame(tick);
      });
    }, 500);
  });

  document.querySelectorAll('.collection__title').forEach(function (t) {
    new IntersectionObserver(function (en, o) { if (en[0].isIntersecting) { t.classList.add('dfz-seen'); o.disconnect(); } }, { threshold: 0.5 }).observe(t);
  });

  // 4. Cartes produit qui apparaissent en cascade (seulement celles sous la ligne de flottaison)
  document.querySelectorAll('.product-card-wrapper').forEach(function (c) {
    var li = c.closest('li');
    if (!li || li.getBoundingClientRect().top < window.innerHeight) return;
    li.setAttribute('data-dfz-reveal', '');
    var idx = Array.prototype.indexOf.call(li.parentNode.children, li);
    li.style.setProperty('--d', (idx % 4) * 90 + 'ms');
    io.observe(li);
  });

  if (fine) {
    // 5. Halo lumineux qui suit la souris sur les tuiles et les photos produit
    document.addEventListener('pointermove', function (ev) {
      var el = ev.target.closest && ev.target.closest('.dfz-cat, .product-card-wrapper .card__media, .dfz-guide__media, .dfz-brand');
      if (!el) return;
      var r = el.getBoundingClientRect();
      el.style.setProperty('--sx', (ev.clientX - r.left) + 'px');
      el.style.setProperty('--sy', (ev.clientY - r.top) + 'px');
    }, { passive: true });

    // 6. Boutons « aimantés » : ils suivent légèrement la souris
    document.querySelectorAll('.dfz-hero .button, .dfz-cta__box .button, .collection__view-all .button').forEach(function (b) {
      b.classList.add('dfz-magnet');
      b.addEventListener('pointermove', function (ev) {
        var r = b.getBoundingClientRect();
        var x = (ev.clientX - r.left - r.width / 2) * 0.18, y = (ev.clientY - r.top - r.height / 2) * 0.3;
        b.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });

    // 7. Impact rouge au clic
    document.addEventListener('pointerdown', function (ev) {
      if (ev.button !== 0) return;
      var s = document.createElement('span');
      s.className = 'dfz-impact';
      s.style.left = ev.clientX + 'px';
      s.style.top = ev.clientY + 'px';
      document.body.appendChild(s);
      setTimeout(function () { s.remove(); }, 600);
    }, { passive: true });
  }

  if (fine) document.querySelectorAll('.dfz-hero__visual').forEach(function (v) {
    v.addEventListener('mousemove', function (ev) {
      var r = v.getBoundingClientRect();
      var x = (ev.clientX - r.left) / r.width - 0.5;
      var y = (ev.clientY - r.top) / r.height - 0.5;
      v.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
      v.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
      v.style.setProperty('--mx', (x * 100 + 50).toFixed(1) + '%');
      v.style.setProperty('--my', (y * 100 + 50).toFixed(1) + '%');
    });
    v.addEventListener('mouseleave', function () { v.style.setProperty('--rx', '0deg'); v.style.setProperty('--ry', '0deg'); });
  });
})();
